"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsAllowedForObfuscationTargets = IsAllowedForObfuscationTargets;
const class_validator_1 = require("class-validator");
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const StringSeparator_1 = require("../../enums/StringSeparator");
const Default_1 = require("../presets/Default");
function IsAllowedForObfuscationTargets(obfuscationTargets, validationOptions) {
    return (optionsObject, propertyName) => {
        (0, class_validator_1.registerDecorator)({
            propertyName,
            constraints: [obfuscationTargets],
            name: 'IsAllowedForObfuscationTargets',
            options: validationOptions,
            target: optionsObject.constructor,
            validator: {
                validate(value, validationArguments) {
                    const options = validationArguments.object;
                    const defaultValue = Default_1.DEFAULT_PRESET[propertyName];
                    const isDefaultValue = (0, fast_deep_equal_1.default)(value, defaultValue);
                    return isDefaultValue || obfuscationTargets.includes(options.target);
                },
                defaultMessage(validationArguments) {
                    const requiredObfuscationTargetsString = obfuscationTargets.join(`${StringSeparator_1.StringSeparator.Comma} `);
                    return `This option allowed only for obfuscation targets: ${requiredObfuscationTargetsString}`;
                }
            }
        });
    };
}
